export default "__VITE_ASSET__DASp_82k__"